export function replaceDynamicSegments(url: string, replacement: string): string {
  return url.replaceAll(/\/\$(opportunityId|id)(\/|$)/g, `/${replacement}$2`);
}

export function getFirstThreeSegments(url: string): string {
  const segments = url.split('/').filter(Boolean); // Split and remove empty segments
  return segments.slice(0, 3).join('/'); // Get first 3 segments and join
}
